import {
  APPINFO,
  APPINFO_SUCCESS,
  CREATEAPPLICATION,
  CREATEAPPLICATION_SUCCESS,
  UPDATEAPPLICATION,
  UPDATEAPPLICATION_SUCCESS,
  FETCHAPPLICATIONS,
  FETCHAPPLICATIONS_SUCCESS,
  FETCHAPPLICATION,
  FETCHAPPLICATION_SUCCESS,
  CHANGEAPPLICATION,
  LOADAPPLICATION,
  FETCHCUSTOMERS,
  FETCHCUSTOMERS_SUCCESS,
  FETCHCUSTOMERINFO,
  FETCHCUSTOMERINFO_SUCCESS,
  DASHBOARDAPPINFO,
  DASHBOARDAPPINFOBYTIME,
  DASHBOARDAPPINFO_SUCCESS,
  DASHBOARDAPPINFOBYTIME_SUCCESS,
  DELETEAPPLICATION,
  DELETEAPPLICATION_SUCCESS,
  CLEARAPPLICATIONS,
  FETCHSUBKEYS,
  FETCHSUBKEYS_SUCCESS,
  GENERATESUBKEY,
  GENERATESUBKEY_SUCCESS,
  DELETESUBKEY,
  DELETESUBKEY_SUCCESS,
  GENERATEKEY,
  GENERATEKEY_SUCCESS,
} from "constants/ActionTypes";

export const fetchAppInfo = (applicationId) => {
  return {
    type: APPINFO,
    payload: {
      applicationId: applicationId
    }
  };
};

export const fetchAppInfoSuccess = (applicationId, appInfo) => {
  return {
    type: APPINFO_SUCCESS,
    applicationId: applicationId,
    payload: appInfo
  };
};

export const fetchDashboardAppInfo = (applicationId) => {
  return {
    type: DASHBOARDAPPINFO,
    payload: {
      applicationId: applicationId
    }
  };
};

export const fetchDashboardAppInfoSuccess = (applicationId, appInfo) => {
  return {
    type: DASHBOARDAPPINFO_SUCCESS,
    applicationId: applicationId,
    payload: appInfo
  };
};

export const fetchDashboardAppInfoByTime = (applicationId, type) => {
  return {
    type: DASHBOARDAPPINFOBYTIME,
    payload: {
      applicationId: applicationId,
      type: type
    }
  };
};

export const fetchDashboardAppInfoByTimeSuccess = (applicationId, type, appInfo) => {
  return {
    type: DASHBOARDAPPINFOBYTIME_SUCCESS,
    applicationId: applicationId,
    payload: appInfo
  };
};

export const fetchApplications = (type) => {
  return {
    type: FETCHAPPLICATIONS,
    payload: {
      type
    }
  };
};

export const fetchApplicationsSuccess = (applications) => {
  return {
    type: FETCHAPPLICATIONS_SUCCESS,
    payload: applications
  };
};

export const fetchApplication = (applicationId) => {
  return {
    type: FETCHAPPLICATION,
    payload: {
      applicationId
    }
  };
};

export const fetchApplicationSuccess = (application) => {
  return {
    type: FETCHAPPLICATION_SUCCESS,
    payload: application
  };
};

export const clearApplications = () => {
  return {
    type: CLEARAPPLICATIONS,
    payload: {
    }
  };
}

export const createApplication = (creatingApplication) => {
  console.log('creatingApplication', creatingApplication)
  return {
    type: CREATEAPPLICATION,
    payload: creatingApplication
  };
};

export const createApplicationSuccess = (createdApplication) => {

  return {
    type: CREATEAPPLICATION_SUCCESS,
    payload: createdApplication
  };
};

export const updateApplication = (updatingApplication) => {
  console.log('updatingApplication', updatingApplication)
  return {
    type: UPDATEAPPLICATION,
    payload: updatingApplication
  };
};

export const updateApplicationSuccess = (updatedApplication) => {
  console.log('updatedApplication', updatedApplication)

  return {
    type: UPDATEAPPLICATION_SUCCESS,
    payload: updatedApplication
  };
};

export const changeApplication = (application) => {
  return {
    type: CHANGEAPPLICATION,
    payload: application
  };
};

export const loadApplication = (application) => {
  return {
    type: LOADAPPLICATION,
    payload: application
  };
};

export const fetchCustomers = (applicationId) => {
  return {
    type: FETCHCUSTOMERS,
    payload: {
      applicationId
    }
  };
};

export const fetchCustomersSuccess = (customers, applicationId) => {
  return {
    type: FETCHCUSTOMERS_SUCCESS,
    applicationId: applicationId,
    payload: customers
  };
};

export const fetchCustomerInfo = (customerId) => {
  return {
    type: FETCHCUSTOMERINFO,
    payload: {
      customerId: customerId
    }
  };
};

export const fetchCustomerInfoSuccess = (customerInfo, customerId) => {
  return {
    type: FETCHCUSTOMERINFO_SUCCESS,
    customerId: customerId,
    payload: customerInfo
  };
};

export const deleteApplication = (deletingApplication) => {

  return {
    type: DELETEAPPLICATION,
    payload: deletingApplication
  };
};

export const deleteApplicationSuccess = (deletedApplication) => {

  return {
    type: DELETEAPPLICATION_SUCCESS,
    payload: deletedApplication
  };
};

export const deleteSubKey = (subKeyId) => {

  return {
    type: DELETESUBKEY,
    payload: subKeyId
  };
};

export const deleteSubKeySuccess = (deletedSubKey) => {

  return {
    type: DELETESUBKEY_SUCCESS,
    payload: deletedSubKey
  };
};

export const generateKey = (applicationId) => {

  return {
    type: GENERATEKEY,
    payload: {
      applicationId
    }
  };
};

export const generateKeySuccess = (payload, applicationId) => {

  return {
    type: GENERATEKEY_SUCCESS,
    applicationId: applicationId,
    payload: payload
  };
};

export const generateSubKey = (applicationId, alias) => {

  return {
    type: GENERATESUBKEY,
    payload: {
      applicationId,
      alias
    }
  };
};

export const generateSubKeySuccess = (generatedSubKeys) => {

  return {
    type: GENERATESUBKEY_SUCCESS,
    payload: generatedSubKeys
  };
};

export const fetchSubKeys = (application) => {

  return {
    type: FETCHSUBKEYS,
    payload: application
  };
};

export const fetchSubKeysSuccess = (subKeys) => {

  return {
    type: FETCHSUBKEYS_SUCCESS,
    payload: subKeys
  };
};
